/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { useStoreActions, useStoreState } from 'easy-peasy';

import i18n from '../../../i18n';
import ArrowDown from '../../../assets/icons/ArrowDown';
import GlobeIcon from '../../../assets/icons/GlobeIcon';
import { mobile } from '../../../constants/breakpoints';

import { colourStyles, languages, saveLanguage } from './helpers';

export const LanguageSelector = ({ menuPortalTarget = document.body }) => {
  const { userData } = useStoreState(state => state.user);
  const { theme } = useStoreState(actions => actions.theme);
  const { setAuthLoader } = useStoreActions(actions => actions.authentication);
  const [selectedLanguage, setSelectedLanguage] = useState(
    JSON.parse(localStorage.getItem('language')) || languages[0]
  );
  const isMobile = useMediaQuery({ query: `(max-width: ${mobile}px)` });

  const saveLanguageHandler = async e => {
    await saveLanguage(e, userData?.Id).then(() => {
      // silent err
    });
    window.location.reload();
  };

  const handeChange = e => {
    setAuthLoader(true);
    i18n.changeLanguage(e.value);
    localStorage.setItem('language', JSON.stringify(e));
    if (selectedLanguage === 'en') {
      setSelectedLanguage(e);
    } else if (selectedLanguage === 'pt') {
      setSelectedLanguage(e);
    } else if (selectedLanguage === 'it') {
      setSelectedLanguage(e);
    } else if (selectedLanguage === 'de') {
      setSelectedLanguage(e);
    } else if (selectedLanguage === 'fr') {
      setSelectedLanguage(e);
    } else if (selectedLanguage === 'ja') {
      setSelectedLanguage(e);
    }
    saveLanguageHandler(e.value);
  };

  return (
    <Container isMobile={isMobile}>
      <GlobeIcon width="14" fill={theme.themes.colorPrimary} />
      <Select
        isSearchable={false}
        onChange={e => e?.value !== selectedLanguage?.value && handeChange(e)}
        defaultValue={selectedLanguage}
        options={languages}
        styles={colourStyles(theme, isMobile)}
        menuPortalTarget={menuPortalTarget}
        components={{
          DropdownIndicator: () => (
            <ArrowDown
              fill={theme.themes.colorPrimary}
              extraStyle={{ marginLeft: 5, marginRight: 15 }}
            />
          )
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  border-radius: ${({ isMobile }) => (isMobile ? '20px' : '5px')};
  max-width: ${({ isMobile }) => (isMobile ? 'max-content' : '240px')};
  border: 1px solid #f1f1f1;
  padding-left: 15px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: ${({ theme }) => theme.themes.colorPrimary};
  cursor: pointer;
`;

LanguageSelector.propTypes = {
  menuPortalTarget: PropTypes.object
};
